import client from '../base-api';

const serviceURL = '/address-book/private-customer';

const addressBookDoctorService = {

    getPrivateCustomers(filterData: any) {
        return client.get(`${serviceURL}`, {params: filterData});
    },

    getPrivateCustomer(privateCustomerId: number) {
        return client.get(`${serviceURL}/${privateCustomerId}`);
    },

    postPrivateCustomer(privateCustomerData: any) {
        return client.post(`${serviceURL}`, privateCustomerData);
    },

    putPrivateCustomer(privateCustomerData: any, privateCustomerId: number) {
        return client.put(`${serviceURL}/${privateCustomerId}`, privateCustomerData);
    },

    deletePrivateCustomer(privateCustomerId: number) {
        return client.put(`${serviceURL}/delete/${privateCustomerId}`);
    },

};

export default addressBookDoctorService;
  